import { useApi } from 'app/context';
import { useCallback, useEffect } from 'react';
import { useBasePaginatedList } from './useBasePaginatedList';
import { IMedicalCenterSchema } from 'generated/axios';

export const useMedicalCenterList = () => {
  const { medicalCenterApi } = useApi();

  const {
    list,
    page,
    handlePageChange,
    pageSize,
    handlePageSizeChange,
    loading,
    setLoading,
    count,
    filter,
    handleFilter,
    handleError,
    handleSuccess,
  } = useBasePaginatedList<IMedicalCenterSchema>();

  //GET
  const get = useCallback(() => {
    setLoading(true);
    medicalCenterApi
      .adminPaginateMedicalCenter(page, pageSize, filter)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        handleSuccess(resp.data.results, resp.data.total);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medicalCenterApi, page, pageSize, filter]);

  useEffect(() => {
    get();
  }, [get]);

  return { list, page, handlePageChange, pageSize, handlePageSizeChange, loading, count, filter, handleFilter };
};
